import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import Template from "../../template";
import { useCorrecao } from "../../context/correcao";
import CorrecaoResultadoUI from "../../components/CorrecaoResultadoUI";

export default function CorrecaoIAResultado() {
  const history = useHistory();

  // evita tela branca se o provider não estiver montado
  let correcaoData = null;
  let imageData = null;

  try {
    const ctx = useCorrecao();
    correcaoData = ctx?.correcaoData || null;
    imageData = ctx?.imageData || null;
  } catch (e) {
    correcaoData = null;
    imageData = null;
  }

  if (!correcaoData) {
    return (
      <Template>
        <Container>
          <Row>
            <Col className="text-center mt-5">
              <h3>Correção não encontrada</h3>
              <p className="text-muted">
                Envie uma redação para gerar uma correção, ou acesse suas correções em “Minhas redações”.
              </p>
              <button className="btn btn-primary mt-3" onClick={() => history.push("/minhas-redacoes?tipo=ia")}>
                Ir para Minhas redações
              </button>
            </Col>
          </Row>
        </Container>
      </Template>
    );
  }

  const competencias = {
    c1: correcaoData.competencies?.competencia_1 ?? 0,
    c2: correcaoData.competencies?.competencia_2 ?? 0,
    c3: correcaoData.competencies?.competencia_3 ?? 0,
    c4: correcaoData.competencies?.competencia_4 ?? 0,
    c5: correcaoData.competencies?.competencia_5 ?? 0,
  };

  const comentarios = {
    c1: correcaoData.comments?.competencia_1 ?? "",
    c2: correcaoData.comments?.competencia_2 ?? "",
    c3: correcaoData.comments?.competencia_3 ?? "",
    c4: correcaoData.comments?.competencia_4 ?? "",
    c5: correcaoData.comments?.competencia_5 ?? "",
  };

  return (
    <Template>
      <CorrecaoResultadoUI
        title="Correção da Redação - Inteligência Artificial"
        notaFinal={correcaoData.final_score ?? 0}
        competencias={competencias}
        comentarios={comentarios}
        imageUrl={imageData || null}
        onBack={() => history.push("/enviar-redacao")}
        extraActions={
          <button className="btn btn-outline-primary" onClick={() => history.push("/minhas-redacoes?tipo=ia")}>
            Ir para Minhas redações
          </button>
        }
      />
    </Template>
  );
}